import { render, staticRenderFns } from "./LayoutNavigation.vue?vue&type=template&id=2437b47e&scoped=true&"
import script from "./LayoutNavigation.vue?vue&type=script&lang=js&"
export * from "./LayoutNavigation.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNavigation.vue?vue&type=style&index=0&id=2437b47e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437b47e",
  null
  
)

export default component.exports